import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BenefitsComponent } from './benefits/benefits.component';
import {
    CardModule,
    ClubStoreModule,
    SystemIconModule,
    ButtonModule,
    AlertModule,
    ModalsModule,
    InputModule,
    SosAccountStoreModule,
} from '@serviceos-ng/core';
import { ClubStatsComponent } from './club-stats/club-stats.component';
import { ClubCancelModalComponent } from './club-cancel-modal/club-cancel-modal.component';
import { BenefitsListComponent } from './benefits-list/benefits-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        BenefitsComponent,
        ClubStatsComponent,
        ClubCancelModalComponent,
        BenefitsListComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ClubStoreModule,
        SosAccountStoreModule,
        CardModule,
        ButtonModule,
        SystemIconModule,
        ModalsModule,
        InputModule,
        AlertModule,
    ],
    exports: [BenefitsComponent, ClubStatsComponent, ClubCancelModalComponent],
})
export class ClubModule {}
